module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "bestsell3.73940ec6.jpeg" + "?" + Date.now();